import { handleResponse, Headers } from '../_helpers';

export const CalendarService = {
  // fetchByWorld,
  fetchByChronicle,
  fetchById,
  createNew,
  update,
  delete: deleteCalendar,
};

function fetchByWorld(worldID) {}

function fetchByChronicle(chronicleID) {
  const request = {
    method: 'GET',
    headers: Headers.set(),
  };

  return fetch(
    `${process.env.API_URL}/api/v1/calendar/chronicle/${chronicleID}`,
    request
  )
    .then(handleResponse)
    .then((calendars) => calendars);
}

function fetchById(calendarID) {
  const request = {
    method: 'GET',
    headers: Headers.set({ auth: false }),
  };

  return fetch(`${process.env.API_URL}/api/v1/calendar/${calendarID}`, request)
    .then(handleResponse)
    .then((calendar) => calendar);
}

function createNew(calendarData) {
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(calendarData),
  };

  return fetch(`${process.env.API_URL}/api/v1/calendar/new`, request)
    .then(handleResponse)
    .then((calendar) => calendar);
}

function update(calendarID, calendarData) {
  const request = {
    method: 'PUT',
    headers: Headers.set(),
    body: JSON.stringify(calendarData),
  };

  return fetch(`${process.env.API_URL}/api/v1/calendar/${calendarID}`, request)
    .then(handleResponse)
    .then((calendar) => calendar);
}

function deleteCalendar(calendarID) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/calendar/${calendarID}`, request)
    .then(handleResponse)
    .then(() => calendarID);
}
